
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';
import { ShowCaseHelper } from '@/helpers/trial';

interface CourseCurriculum {
  module: string;
  moduleMicrocertificateName: string;
  disciplines: string[];
}

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    courseSlug: {
      type: String,
      required: true,
    },
  },
  computed: {
    coursesCurriculum(): CourseCurriculum[] {
      return this.$t(
        `trial.showCase.modals.curriculum.courses.${this.courseSlug}`,
      ) as any as CourseCurriculum[];
    },
    currentPeriod(): number {
      const enrollmentStartDate = this.$store.getters.currentUser.enrollments[0].createdAt;
      return ShowCaseHelper.getCurrentPeriodByEnrollmentStartDate(enrollmentStartDate);
    },
  },
  methods: {
    renderCta(module: string): boolean {
      let period;
      const moduleA = 'Módulo 1A';
      const moduleB = 'Módulo 1B';
      if (module === moduleA) {
        period = 0;
      } else if (module === moduleB) {
        period = 1;
      } else {
        period = null;
      }
      return period === this.currentPeriod;
    },
  },
});
